export default "__VITE_ASSET__dcedf147__"